import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConsoleErrorViewService implements ErrorHandler{

  constructor() { }
  handleError(error: any) {
    console.error(error.stack.toString());
  }
}
